module.exports = __webpack_public_path__ + "img/Deathknight-draenei-f-70.3291eda4.gif";